<template>
<div class="body-zone" >
  <div class="header-fixed herdershadow">
    <div class="header-zone" >
      <b-navbar toggleable="md" type="dark" variant="info">
      <b-navbar-brand @click="gohome()">
        <img class="web_logo" src="../../assets/images/logo.png" alt="">
        <img class="h5_logo" src="../../assets/images/logo_h5.svg" alt="">
      </b-navbar-brand>
      <i class="min_cn" @click="switchLang('en')" v-show="this.lang=='中文'">EN</i>
      <i class="min_en" @click="switchLang('zh_cn')" v-show="this.lang=='English'">中文</i>
      <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
      <b-collapse is-nav id="nav_collapse">
        <b-navbar-nav class="ml-auto">
          <b-nav>
            <b-nav-item href="/">{{$t('Nav.Home')}}</b-nav-item>
            <b-nav-item  href="/service">{{$t('Nav.TeSe')}}</b-nav-item>
            <li class="nav-item hangye">
              <p>{{$t('Nav.FangAn')}}</p>
              <div class="hangye_xuanze_zone">
                 <div class="hangye_xuanze">
                  <b-nav-item class="link" href="/asset">{{$t('Nav.FangAn1')}}</b-nav-item>
                  <b-nav-item class="link" href="/finance">{{$t('Nav.FangAn2')}}</b-nav-item>
                  <b-nav-item class="link" href="/digital">{{$t('Nav.FangAn3')}}</b-nav-item>
                  <b-nav-item class="link"  href="/origin">{{$t('Nav.FangAn4')}}</b-nav-item>
                </div>
              </div>
            </li>
            <b-nav-item class="top_active" @click="refresh">{{$t('Nav.About')}}</b-nav-item>
          </b-nav>
        </b-navbar-nav>
        <!-- <div class="lang">
          <span @click="switchLang('zh_cn')">中文</span>
          <i class="lang_line"></i>
          <span @click="switchLang('en')">EN</span>
        </div> -->
      </b-collapse>
    </b-navbar>
    </div>
  </div>
  <div class="about-banner">
    <p class="title">{{$t('About.BannerFt1')}}</p>
    <p class="ft">{{$t('About.BannerFt2')}}</p>
  </div>
  <b-container class="about_banner1">
    <h4 class="title">
      {{$t('About.BannerFt3')}}
    </h4>
    <div class="about_banner1_zone">

      <div class="about-info">
        <img class="img1"  src="../../assets/images/photo_1.png" alt="">
        <p class="photo_title">{{$t('About.BannerFt4')}}</p>
        <p class="photo_ft">{{$t('About.BannerFt5')}}</p>
      </div>
      <div class="about-info">
        <img class="img1"  src="../../assets/images/photo_2.png" alt="">
        <!-- <i class="photo_i">simba</i> -->
        <p class="photo_title">{{$t('About.BannerFt6')}}</p>
        <p class="photo_ft">{{$t('About.BannerFt7')}}</p>
      </div>
      <div class="about-info">
        <img class="img1"  src="../../assets/images/photo_3.png" alt="">
        <p class="photo_title">{{$t('About.BannerFt8')}}</p>
        <p class="photo_ft">{{$t('About.BannerFt9')}}</p>
      </div>
    </div>
  </b-container>
  <b-container class="about_banner2">
    <h4 class="title">
      {{$t('About.BannerFt10')}}
    </h4>
    <div id="allmap"></div>
    <div class="map-info-zone">
      <div class="map-info-left">
        <p>{{$t('About.BannerFt11')}}</p>
        <p>{{$t('About.BannerFt12')}}</p>
      </div>
       <div class="map-info-right">
        <p>{{$t('About.BannerFt13')}}</p>
        <p>{{$t('About.BannerFt14')}}</p>
        <p>{{$t('About.BannerFt15')}}</p>
      </div>
    </div>
  </b-container>
    <Bottom></Bottom>
    <div v-bind:class="{goTopShow: isActive }" @click="toTop(step)" class="go-top-zone">
      <i></i>
    </div>
</div>

</template> 

<script>
import storage from '../../models/storage';
import Bottom from "@/pages/assembly/Bottom"
export default {
  name: "RedDetail",
  components: {Bottom},
  props:{
            step:{   //此数据是控制动画快慢的
                type:Number,
                default:120  
            }
        },
  data() {
    return {
      lang:'中文',
      openLang:false,
      isActive:false
    };
  },
   mounted() {
     window.addEventListener('scroll', this.handleScroll)
    let lang=storage.get('lang')
     if(lang=='en'){
        this.lang = 'English'
        this.langnum=1
      }
      if(lang=='zh_cn'){
        this.lang = '中文'
        this.langnum=0
      }

    // 百度地图API功能
	
	// 百度地图API功能
	var map = new BMap.Map("allmap");
	var point = new BMap.Point(114.038076,22.5358);
	var marker = new BMap.Marker(point);  // 创建标注
	map.addOverlay(marker);              // 将标注添加到地图中
  map.centerAndZoom(point, 25);
  map.enableScrollWheelZoom();   //启用滚轮放大缩小，默认禁用
  map.enableContinuousZoom();    //启用地图惯性拖拽，默认禁用
  // marker.setAnimation(BMAP_ANIMATION_BOUNCE); //跳动的动画
	var opts = {
	  position : point,    // 指定文本标注所在的地理位置
	  offset   : new BMap.Size(30, -30)    //设置文本偏移量
	}
	var label = new BMap.Label("深圳博洛科技有限责任公司", opts);  // 创建文本标注对象
		label.setStyle({
			 color : "red",
			 fontSize : "12px",
			 height : "20px",
			 lineHeight : "20px",
       fontFamily:"微软雅黑"
     });
     map.addOverlay(label); 
	var infoWindow = new BMap.InfoWindow("地址：深圳市福田区天安数码城创新科技广场二期西座501", opts);  // 创建信息窗口对象 
	marker.addEventListener("click", function(){          
		map.openInfoWindow(infoWindow,point); //开启信息窗口
  });
  label.addEventListener("click", function(){          
		map.openInfoWindow(infoWindow,point); //开启信息窗口
	});
   },
   created(){
     this.menu()
   },
  methods: {
     menu() {
      window.scrollTo(0,0);
      },
    toTop(i){
                //参数i表示间隔的幅度大小，以此来控制速度
                document.documentElement.scrollTop-=i;
                if (document.documentElement.scrollTop>0) {
                    var c=setTimeout(()=>this.toTop(i),16);
                }else {
                    clearTimeout(c);
                }
            },
    handleScroll () {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if(scrollTop!=0){
        this.isActive = true
      }
      else{
        this.isActive = false
      }
    },
    refresh(){
      this.$router.push({path: "/about"});
      window.scrollTo(0,0);
      window.location.reload()
    },
    gohome(){
      this.$router.push({path: "/"});
      window.scrollTo(0,0);
      window.location.reload()
    },



    enter(){
      this.openLang=true
    },
    leave(){
      this.openLang=false
    },
    switchLang(lang)  {
      if(lang=='en'){
        this.lang = 'English'
      }
      if(lang=='zh_cn'){
        this.lang = '中文'
      }
        this.$i18n.locale = lang
        storage.set('lang',lang);
    },
    get_history: function (uuid) {
          luckmoney.getHistory(uuid).then(result => {
          }).catch(e => {
            console.log(e)
          })
        },
  }
};
</script>
<style  lang="scss"  scoped>
  @import "../../assets/css/Index.scss";  
</style>


// WEBPACK FOOTER //
// src/pages/about/About.vue